import React from "react";
import sanitizeHtml, { IOptions } from 'sanitize-html';

const defaultOptions: IOptions = {
  allowedTags: ['b', 'i', 'em', 'strong', 'a', 'img', 'tr', 'td', 'table', 'p', 'tbody', 'thead', 'strong', 'br'],
  allowedAttributes: {
    'a': ['href'],
    'img': ['src', 'alt', 'width', 'height'],
    'p': ['style'],
    'table': ['style'],
    'td': ['style'],
    'tr': ['style'],
  },
  allowedIframeHostnames: ['www.youtube.com']
};

const sanitize = (
  dirty: string, options: IOptions | undefined
) => ({
  __html: sanitizeHtml(
    dirty,
    {
      ...defaultOptions,
      ...options
    },
  )
});

export interface SanitizeHTMLProps {
  html: string;
  options?: IOptions;
}

export const SanitizeHTML = ({
  html, options
} : SanitizeHTMLProps) =>
  <div dangerouslySetInnerHTML={sanitize(
    html,
    options
  )} />
;